import React from "react";
import * as styles from "../typography/typography.module.scss";

/**
 * @type {Object} 「UI:atoms - ブロックコンポーネント タイトル コンポーネント」DOMです。
 * @return {Object} DOMを返します。
 * @param {Array} props コンポーネントを受け取るための引数です。コンポーネントに任意の値を渡します。（ref.https://ja.react.dev/learn/passing-props-to-a-component）
 * @param {String} props.text タイトルに設定した文字列を受け取るための引数です。
 *
 */

const BlockTitle = (props) => {
  return (
    <p className={`${styles.blockTitle}`}>
      <strong>{props.text}</strong>
    </p>
  );
};

export default BlockTitle;
